/**
 * Takes a URL and adds a listener to the element that makes long-touching open
 * the URL as if it was a link.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
    duration: { type: Number, default: 500 },
    turboStream: { type: Boolean, default: true },
    moveThreshold: { type: Number, default: 8 },
  };

  connect() {
    this.hiddenLink = document.createElement("a");
    this.hiddenLink.href = this.urlValue;
    this.hiddenLink.classList.add("d-none");
    if (this.turboStreamValue) {
      this.hiddenLink.dataset["turboStream"] = "";
    }

    this.element.append(this.hiddenLink);
    this.touchTimer = null;
    this.initialTouchCoords = { x: null, y: null };

    this.element.addEventListener("touchstart", this.touchStart.bind(this));
    this.element.addEventListener("touchend", this.touchEnd.bind(this));
    this.element.addEventListener("touchcancel", this.touchEnd.bind(this));
    this.element.addEventListener("touchmove", this.touchMove.bind(this));
  }

  touchStart(e) {
    const touch = e.touches[0];
    this.initialTouchCoords = { x: touch.clientX, y: touch.clientY };
    this.touchTimer = setTimeout(this.clickLink.bind(this), this.durationValue);
    this.element.classList.add("touch-held");
  }

  touchEnd() {
    this.initialTouchCoords = { x: null, y: null };
    this.element.classList.remove("touch-held");
    if (this.touchTimer) {
      clearTimeout(this.touchTimer);
      this.touchTimer = null;
    }
  }

  touchMove(e) {
    if (this.touchTimer) {
      const touch = e.touches[0];
      const distX = Math.abs(touch.clientX - this.initialTouchCoords.x);
      const distY = Math.abs(touch.clientY - this.initialTouchCoords.y);
      if (distX > this.moveThresholdValue || distY > this.moveThresholdValue) {
        this.touchEnd();
      }
    }
  }

  clickLink() {
    this.hiddenLink.click();
  }
}
